import axAPI from '../httpConfig'

export default class ConstantsApiService {
	static getConstants = async () => {
		return axAPI({
			method: 'GET',
			url: '/constants',
		})
	}
	static updateConstants = async (data: { next_trim_fixed_days: number }) => {
		const response = await axAPI.patch('/constants', data)
		return response.data
	}
}
